module.exports = __webpack_public_path__ + "img/home_buy_bg.108783f8.png";